import { RUOLI } from "@/lib/constants";

export function RoleBadge({ role, className = "", testId }) {
  const r = RUOLI[role] || { label: role, cls: "bg-slate-100 text-slate-700 border-slate-200" };
  return (
    <span data-testid={testId} className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap ${r.cls} ${className}`}>
      {r.label}
    </span>
  );
}

export function StatusBadge({ map, value, testId }) {
  const s = map[value] || { label: value, cls: "bg-slate-100 text-slate-700" };
  return (
    <span data-testid={testId} className={`inline-flex items-center rounded-full border border-transparent px-2.5 py-0.5 text-xs font-medium whitespace-nowrap ${s.cls}`}>
      {s.label}
    </span>
  );
}
